let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7vBa2")).then(() => parcelRequire('bjtFX'));